import { chainId } from './index';

const getwebsiteAccessKey = () => {
    let wak = new URLSearchParams(window.location.search).get('wak');
    const now = new Date();

    if (!wak) {
        const latestWebsiteAccessToken = JSON.parse(localStorage.getItem('wak'));
        if (latestWebsiteAccessToken && latestWebsiteAccessToken.chainId === chainId && now.getTime() < latestWebsiteAccessToken.expiry) {
            wak = latestWebsiteAccessToken.accessKey;
        }
    } else {
        const expiry = now.getTime() + (1000 * 60 * 60 * 5);
        localStorage.setItem('wak', JSON.stringify({ accessKey: wak, chainId, expiry }));
    }

    return wak;
};

export default getwebsiteAccessKey();